/**
 * 生成 UUID
 */
export function generateUUID(): string {
  return (
    [1e7].toString() +
    (-1e3).toString() +
    (-4e3).toString() +
    (-8e3).toString() +
    (-1e11).toString()
  )
    .replace(/[018]/g, (c: string) => {
      const randomValue = crypto.getRandomValues(new Uint8Array(1))[0];
      const bitwise = Number.parseInt(c, 10) ^ (randomValue & (15 >> (Number.parseInt(c, 10) / 4)));
      return bitwise.toString(16);
    })
    .replace(/-/g, '');
}
